import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  catalogList: [],
  orderList: [],
  orderDetailList: [],
  cartList: [],
  catalogDetail: [],
  catalogItemsList: [],
  loading: false,
  cartCounterItems: 0,
  error: undefined,
};

const catalogSlice = createSlice({
  name: "catalog",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchCatalogList(state, action) {
      state.catalogList = action.payload;
      state.loading = false;
    },
    fetchOrderList(state, action) {
      state.orderList = action.payload;
      state.loading = false;
    },
    fetchOrderDetailList(state, action) {
      state.orderDetailList = action.payload;
      state.loading = false;
    },
    fetchCartList(state, action) {
      state.cartList = action.payload;
      state.loading = false;
    },
    fetchCatalogDetail(state, action) {
      state.catalogDetail = action.payload;
      state.loading = false;
    },
    fetchClearCatalogList(state, action) {
      state.catalogList = action.payload;
      state.loading = false;
    },
    fetchCartTotalCounterItems(state, action) {
      state.cartCounterItems = action.payload;
      state.loading = false;
    },
    fetchCatalogStart(state, action) {
      state.catalogItemsList = action.payload;
      state.loading = false;
    },
  },
});

export const catalogActions = catalogSlice.actions;

export default catalogSlice.reducer;
